import { render } from "./organisations-table.vue?vue&type=template&id=0974f496"
import script from "./organisations-table.vue?vue&type=script&lang=js"
export * from "./organisations-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__